export enum MapStyle {
  VECTOR = 'VECTOR',
  SATELLITE = 'SATELLITE',
}
